module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/domofon-2-0176df88f5e28d7523ae3ed3d7a786f8.webp";